import React, { useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Divider,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CartItemCard from "../../pages/Cart/CartItemCard";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import CartSummaryBreakdown from "../../components/cart/CartSummaryBreakdown";

const SharedCartPreview = () => {
  const {
    discountedCartItems,
    removeFromCart,
    showCartPreview,
    setShowCartPreview,
    cartSubtotal,
    totalDiscount,
    cartTotal,
  } = useCart();

  const navigate = useNavigate();

  useEffect(() => {
    if (showCartPreview) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [showCartPreview]);

  return (
    <>
      {showCartPreview && (
        <Box
          onClick={() => setShowCartPreview(false)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            zIndex: 1200,
          }}
        />
      )}

      <Slide
        direction="left"
        in={showCartPreview}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 300, exit: 300 }}>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            width: { xs: "90vw", sm: 360 },
            height: "100dvh",
            maxHeight: "100vh",
            bgcolor: "white",
            boxShadow: "-4px 0px 10px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            p: 3,
            zIndex: 1300,
          }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <Typography variant="h6" fontWeight="bold">
              Cart Preview
            </Typography>
            <IconButton onClick={() => setShowCartPreview(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Items */}
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            {discountedCartItems.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                Your cart is empty.
              </Typography>
            ) : (
              discountedCartItems.map((item, index) => (
                <CartItemCard
                  key={index}
                  cartItem={item}
                  onDelete={() => removeFromCart(item)}
                  variant="preview"
                />
              ))
            )}
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Footer */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              pb: 3,
              mb: 3,
              mt: 1,
            }}>
            <CartSummaryBreakdown
              subtotal={cartSubtotal}
              total={cartTotal}
              totalDiscount={totalDiscount}
              showTaxNote={true}
            />

            <Button
              variant="outlined"
              onClick={() => setShowCartPreview(false)}>
              Continue Shopping
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowCartPreview(false);
                navigate("/cart");
              }}>
              Go to Cart
            </Button>
          </Box>
        </Box>
      </Slide>
    </>
  );
};

export default SharedCartPreview;
